
import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { ModalServiceAncillaries } from '../../ib-modal/services/ib-modal-ancillaries-service';
import { NewSeatsMapService } from '../service/ib-new-seat-map-service';
import { AncillariesService } from '../../ib-web-ancillaries/ib-web-ancillaries-service';
import { Subscription } from 'rxjs';
import { AncillariesUtilsService } from 'src/app/shared/ib-web-ancillaries-utils';
import { DatalayerConstantsType } from 'ib-web-commons/dist/ib-datalayer/ib-datalayer-constants';

const controllerInfo = {
    module: 'ib-new-seat-map-module',
    inject: [
        '$uibModalInstance',
        'object',
        '$rootScope',
        'CurrencyService',
        'localStorageService',
        'NewSeatsMapService',
        'AncillariesUtilsService',
        '$window'
    ],
    required: []
};


export class NewConfirmationSeatMapModalController implements angular.IController {

    model: any;
    showExpanded: boolean = true;
    currentSeatmapData: any;
    isLoading: boolean = true;
    isLoadingConfirmSeats: boolean = false;
    flowApp: string;
    isAnySliceExpanded: boolean = false;
    showModalAvios: boolean = false;
    seatAvios: any[] =[];
    private totalSeatsPriceSubscription: Subscription | undefined;
    private seatAviosSubscription: Subscription | undefined;
    private totalSeatsPrice: string;

    constructor (
        private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
        private object: any,
        private $rootScope: CommonsRootScope,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private NewSeatsMapService: NewSeatsMapService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $window: ng.IWindowService
    ) {
        this.model = object;
    }

    $onInit (): void {
        this.isLoading = true;
        this.flowApp = this.localStorageService.get('flowApp');
        this.model.slicesInfo = this.NewSeatsMapService.getSlicesSeatmapInfo();
        this.currentSeatmapData = this.NewSeatsMapService.getCurrentSeatmapData() ? this.NewSeatsMapService.getCurrentSeatmapData() : this.localStorageService.get('currentSeatmapData');

        this.loadSeatmapSegments();
        this.initSeatAvios();
        this.getTotalSeatsPrice();
        this.initRenacen3dScript();
    }

    $onDestroy (): void {
        this.totalSeatsPriceSubscription.unsubscribe();
        this.seatAviosSubscription.unsubscribe();
    }

    private getTotalSeatsPrice (): void {
        this.totalSeatsPriceSubscription = this.NewSeatsMapService.totalSeatsPrice.subscribe((totalSeatsPrice: any) => {
            this.totalSeatsPrice = totalSeatsPrice;
            //show avios
            this.showModalAvios = totalSeatsPrice.total > 0 && this.AncillariesUtilsService.validatedFlightAviosInfo();
        });
    }

    private initSeatAvios (): void {
        this.seatAviosSubscription = this.NewSeatsMapService.aviosAncillariesSeats.subscribe((seatAvios: any[]) => {
            this.seatAvios = seatAvios;
        });
        this.NewSeatsMapService.setSeatAvios(this.seatAvios.length > 0 ? this.seatAvios : (this.localStorageService.get('genAviosAncillariesSeat') || []));

    }


    loadSeatmapSegments (): any  {
        if(!this.model.slicesInfo || !this.model.isSelectedSegmentFromMobileSummary) {
            this.NewSeatsMapService.loadSeatmapSegments().then((slices: any) => {
                this.model.slicesInfo = slices;
                this.updateSeatmapInfoResponse();
            }).catch((error: any) => {
                this.isLoading = false;
                this.$uibModalInstance.close(true);
            });
        } else {
            this.updateSeatmapInfoResponse();
        }
    }

    private updateSeatmapInfoResponse () {
        this.addCurrentSelectedSeats();
        this.NewSeatsMapService.calculateTotalSeatPrice(this.model.slicesInfo, this.model.currency);
        this.isLoading = false;
    }

    private addCurrentSelectedSeats (): void {
        if(this.currentSeatmapData !== null) {
            this.model.slicesInfo.forEach((slice: any) => {
                slice.segments.forEach((segment: any) => {
                    if(this.currentSeatmapData[segment.segmentInfo.id]) {
                        segment.passengersInfo.forEach((passenger: any) => {
                            if(this.currentSeatmapData[segment.segmentInfo.id][passenger.id]
                                && !this.currentSeatmapData[segment.segmentInfo.id][passenger.id].isDeletedFromMobile) {
                                passenger.currentSeat.row = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].seat.row;
                                passenger.currentSeat.column = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].seat.column;
                                passenger.seatPrice = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].price;
                                segment.seatsSelected = true;
                            }
                        });
                    }
                });
            });
        }
    }


    close = (): void => {
        this.NewSeatsMapService.cancelSeatMap().then((dismissModal: boolean) => {
            if(dismissModal) {
                this.$uibModalInstance.close(true);
            }
        });
    };

    filterCurrency = (price: any): any => {
        return price > 0 ? this.CurrencyService.formatPrice(this.model.currency, price, false, false) : this.CurrencyService.formatPrice(this.model.currency, 0, false, false);
    };

    /**
     * Close window and open seat map of segment selected to modify
     * @param {*} segmentId
     */
    modifySegment = (segmentId): void => {
        this.NewSeatsMapService.setIsSelectedSegmentFromMobileSummary(true);
        this.$rootScope.$broadcast('modifySeatMap', segmentId);
        this.$uibModalInstance.close(true);
    };

    confirmSelectedSeats (): void {

        const unselectedSegments: boolean = this.NewSeatsMapService.getIfUnselectedSegments();
        if (this.localStorageService.get('earlyCheckinCode') && unselectedSegments) {
            this.NewSeatsMapService.showModalEarlyCKI();
        } else {
            this.updateSelectedSeats();
        }
    }

    private updateSelectedSeats (): void {
        this.isLoadingConfirmSeats = true;
        this.isLoading = true;
        this.NewSeatsMapService.confirmSelectedSeats().then(() => {
            this.$uibModalInstance.close(true);
        },
        () => {
            this.$uibModalInstance.close();
        });
    }

    /*
    ** open modal avios
    */
    openModalAviosSeatAncillaries = (): void => {
        this.NewSeatsMapService.openModalAviosSeatAncillaries(this.seatAvios);
    };

    backToMain = () => {
        this.NewSeatsMapService.backToMain(true);
    };

    private initRenacen3dScript () {
        if (!this.$window.SeatMapVr) {
            this.NewSeatsMapService.initRenacen3dScript();
        }
    }
}



try {
    NewConfirmationSeatMapModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(NewConfirmationSeatMapModalController.name, NewConfirmationSeatMapModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    NewConfirmationSeatMapModalController.$inject = controllerInfo.inject;
    mod.controller(NewConfirmationSeatMapModalController.name, NewConfirmationSeatMapModalController);
}